module.exports = __webpack_public_path__ + "img/Binance.028e445f.png";